<app-preloader></app-preloader>
<app-holidays *ngIf="showPopup" (closed)="showPopup = false"></app-holidays>
<router-outlet></router-outlet>
<app-footer></app-footer>
